import React from 'react';
import reactStringReplace from 'react-string-replace';
import { FootnoteReference } from '../../components';
function replaceTextWithCallbackResult(text, cb) {
    let textWithReplacedFootnotes;
    textWithReplacedFootnotes = reactStringReplace(text, /{?{ft_([a-zA-Z0-9_-]+)}}?/g, cb);
    textWithReplacedFootnotes = reactStringReplace(textWithReplacedFootnotes, /{{footnote.reference.([a-zA-Z0-9_-]+)}}/g, cb);
    return textWithReplacedFootnotes;
}
export function replaceFootnotesInText(text) {
    if (!text) {
        return [text];
    }
    const replaceCb = (match, i) => React.createElement(FootnoteReference, { refId: match, key: i });
    return replaceTextWithCallbackResult(text, replaceCb);
}
